import { useState, useCallback } from "react";

interface YouTubeFacadeProps {
  videoUrl: string;
  title: string;
}

const getVideoId = (url: string): string => {
  const match = url.match(/(?:embed\/|watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match?.[1] ?? "";
};

const YouTubeFacade = ({ videoUrl, title }: YouTubeFacadeProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const videoId = getVideoId(videoUrl);
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const loadVideo = useCallback(() => {
    setIsLoaded(true);
  }, []);

  if (isLoaded) {
    return (
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`${videoUrl}?autoplay=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        width={896}
        height={504}
      />
    );
  }

  return (
    <button
      className="absolute inset-0 w-full h-full cursor-pointer group/play bg-foreground/5"
      onClick={loadVideo}
      aria-label={`Play video: ${title}`}
    >
      <img
        src={thumbnailUrl}
        alt={title}
        className="w-full h-full object-cover"
        loading="lazy"
        width={896}
        height={504}
      />
      <div className="absolute inset-0 bg-foreground/20 group-hover/play:bg-foreground/30 transition-colors" />
      {/* YouTube play button */}
      <div className="absolute inset-0 flex items-center justify-center">
        <svg
          className="w-16 h-16 sm:w-20 sm:h-20 text-white drop-shadow-lg group-hover/play:scale-110 transition-transform"
          viewBox="0 0 68 48"
          fill="none"
        >
          <path
            d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74 0.06 13.05 0 24 0 24s0.06 10.95 1.48 16.26c0.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-0.06-10.95-1.48-16.26z"
            fill="#FF0000"
          />
          <path d="M45 24L27 14v20" fill="white" />
        </svg>
      </div>
    </button>
  );
};

export default YouTubeFacade;
